import { createContext } from "react";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { useContext } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyALdGbt62WRjYfvqzWOunMdTDdquazKslA",
  authDomain: "blogger-355814.firebaseapp.com",
  projectId: "blogger-355814",
  storageBucket: "blogger-355814.appspot.com",
  messagingSenderId: "107456418022",
  appId: "1:107456418022:web:7d7f1ed813b54a04696b27",
  measurementId: "G-BJQQ6P3Q9H",
};

export const firebaseApp = initializeApp(firebaseConfig);
export const analytics = getAnalytics(firebaseApp);
const storage = getStorage(firebaseApp);

const FirebaseContext = createContext(null);

export const useFirebase = () => useContext(FirebaseContext);

export const FirebaseProvider = ({ children }) => {
  const handleImageUpload = async (image) => {
    const imageRef = ref(storage, `uploads/images/${Date.now()}-${image.name}`);
    const res = await uploadBytes(imageRef, image);
    return res.ref.fullPath;
  };

  const getImageUrl = (path) => {
    return getDownloadURL(ref(storage, path));
  };

  return (
    <FirebaseContext.Provider value={{ handleImageUpload, getImageUrl }}>
      {children}
    </FirebaseContext.Provider>
  );
};
